import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { decodeHandler, sortArrayLower } from "utils";
import {
  toggleBackupPlansCheckList,
  changeBackupPlansCheckList
} from "store/actions";

import Item from "./Item";
import Empty from "App/BackupPlan/Empty";

function Body(props) {
  const TableData = Object.values(props.backupPlan.backupPlans.data).filter(
    data => data.status !== props.enums.BackupPlanStatus.DELETED
  );
  const TableView = TableData.map(data => {
    return { ...data, devicesLength: data.devices ? data.devices.length : 0 };
  });

  const filterSearch = arr => {
    if (props.search) {
      const filter = arr.filter(data =>
        decodeHandler(data.planName)
          .toLowerCase()
          .includes(props.search.toLowerCase())
      );
      props.getTotalMachines(filter.length);
      return filter;
    } else {
      props.getTotalMachines(arr.length);
      return arr;
    }
  };

  const FilteredView = sortArrayLower(
    filterSearch(TableView),
    props.sortCol.col,
    props.sortCol.order
  );

  useEffect(() => {
    props.setFilteredData(FilteredView);
  }, [props.search, props.sortCol]);

  useEffect(() => {
    props.changeBackupPlansCheckList([]);
  }, [props.search]);

  return (
    <ul
      className="table_container"
      style={{ display: props.totalMachines ? "block" : "none" }}
    >
      {FilteredView.map(data => {
        return <Item data={data} />;
      })}
    </ul>
  );
}

function mapStateToProps(state) {
  return { backupPlan: state.backupPlan, enums: state.common.enums };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleBackupPlansCheckList,
      changeBackupPlansCheckList
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Body);
